export default class RandomUtil {
  static randomString(length) {
    let random_chars = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    let result = '';
    for (let i = length; i > 0; --i) {
      result += random_chars[Math.floor(Math.random() * random_chars.length)];
    }
    return result;
  };
}